// Open drawer
document.addEventListener("click", function(e){
  if(e.target.id === "openMenu"){
    document.getElementById("mobileDrawer").classList.add("open");
  }
});

// Close drawer
document.addEventListener("click", function(e){
  if(e.target.id === "closeMenu"){
    document.getElementById("mobileDrawer").classList.remove("open");
  }
});

// Toggle submenu
document.addEventListener("click", function(e){
  if(e.target.classList.contains("mobile-toggle")){
    let next = e.target.nextElementSibling;
    next.style.display = next.style.display === "block" ? "none" : "block";
  }
});
